/**
 * AITip — dark card showing the weekly practical AI tip.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../utils/constants';

interface AITipProps {
  tip: string;
}

export const AITip: React.FC<AITipProps> = ({ tip }) => {
  return (
    <div
      className="rounded-2xl p-5"
      style={{
        background: 'linear-gradient(135deg, #1e1e2e, #2d2d42)',
        border: '1.5px solid rgba(255,255,255,0.06)',
      }}
    >
      {/* Tag */}
      <span
        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full font-montserrat font-bold text-xs mb-3"
        style={{ background: 'rgba(91,108,255,0.22)', color: '#a5b0ff' }}
      >
        💡 This week's AI tip
      </span>

      {/* Tip text */}
      <p className="font-open-sans text-sm text-neutral-300 leading-relaxed mb-4">
        "{tip}"
      </p>

      {/* CTA */}
      <Link
        to={ROUTES.courses}
        className="font-open-sans text-sm font-semibold transition-opacity hover:opacity-80"
        style={{ color: '#00c2a8' }}
      >
        See the full prompts library →
      </Link>
    </div>
  );
};
